<template>
<div>
  <v-form
    v-model="valid"
    @submit.stop='$emit("save", product)' >
    <v-card class='pa-0 ma-0' flat>
      <v-card-title
        v-if='withTitle'
        class="subheading" >Add a new appointment type:
      </v-card-title>
      <v-card-text>
        <v-layout row wrap >
          <v-flex v-for='field in fields' :key='field.value' v-bind='field.containerAttrs' >
            <v-text-field
              v-if='!field.component'
              :rules="[v => !!v || `${field.text} is required`]"
              v-model='product[field.value]'
              :label='field.text'
              :hint='field.hint'
              v-bind='field.attrs' >
            </v-text-field>
            <component v-else
              :is='field.component'
              v-bind='field.attrs'
              v-on='field.events'
              v-model='product[field.value]' />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if='withCancel'
          @click='$emit("cancel")' flat small >Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn readonly disabled flat small
          v-if='nextRequired' v-text='nextRequired' >
        </v-btn>
        <v-btn
          :disabled="!isValid"
          :loading='request.loading'
          @click='$emit("save", product)'
          color='primary'  >
          Save</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <pre v-text="product" /> -->
  </v-form>
</div>
</template>

<script>
// import SpacePicker from '@/components/pickers/SpacePicker.vue'
import InlineLocationPicker from '@/components/pickers/InlineLocationPicker.vue'
export default {
  name: 'AppointmentTypes',
  components: {
    // SpacePicker
    // LocationPicker
  },
  props: {
    service: { type: Object },
    withTitle: { type: Boolean, default: true },
    withCancel: { type: Boolean, default: false },
    errors: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      valid: false,
      reqId: 'products-update-save-request',
      product: {
        locations: []
      }
    }
  },
  computed: {
    request () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    me () {
      return this.$store.getters.me
    },
    requestStatus () {
      return this.request.status
    },
    currency () {
      return this.defaultCurrency
    },
    isValid () {
      return (this.valid && this.product && this.product.locations && this.product.locations.length > 0)
    },
    nextRequired () {
      if (this.isValid) { return null }
      if (!this.product.title) { return 'Product needs a name' }
      if (!this.product.duration) { return 'How long?' }
      if (!this.product.price) { return 'How much?' }
      if (this.product.locations && this.product.locations.length === 0) { return 'Where?' }
      return null
    },
    fields () {
      return [
        {
          text: 'Name',
          value: 'title',
          hint: 'e.g.: Initial consultation, follow-up consultation, 45 minute therapy session',
          containerAttrs: { xs12: true }
        },
        {
          text: 'Duration',
          value: 'duration',
          hint: 'How long is this appointment type (in minutes)',
          attrs: {
            suffix: 'mins',
            type: 'number'
          },
          containerAttrs: { xs6: true, class: 'pr-2' }
        },
        {
          text: 'Price',
          value: 'price',
          hint: 'We\'ll use this to set the default price. You can edit the price on individual appointments',
          attrs: {
            type: 'number',
            prefix: this.currency
          },
          containerAttrs: { xs6: true, class: 'pl-2' }
        },
        {
          text: 'Location',
          value: 'locations',
          multiple: true,
          attrs: {
            spaceId: this.service.id,
            label: 'Locations',
            hint: 'From which locations is this appointment type available?'
          },
          events: {
            add: () => {
              this.$emit('add:location')
            }
          },
          component: InlineLocationPicker,
          containerAttrs: { xs12: true, class: 'pl-2' }
        }
        // { text: 'Private', value: 'private' },
        // { text: 'Order', value: 'order' }
      ]
    }
  },
  watch: {
    requestStatus () {
      if (this.requestStatus === 201) {
        this.clear()
        this.$emit('created', this.requestStatus.result)
      }
    }
  },
  methods: {
    clear () {
      let vm = this
      this.fields.forEach(element => {
        vm.product[element.value] = null
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AppointmentTypes.vue?1fc44745